export default __webpack_public_path__ + "static/media/acv-logo_zh-TW.c60589d4.png";